import React from 'react';
import { motion } from 'framer-motion';
import { Download, CheckCircle, AlertTriangle } from 'lucide-react';
import WindowsLogo from '../components/WindowsLogo';

const handleDownload = () => {
  const downloadUrl = 'https://winmaxoptimizer.com/WinMaxOptimizer.exe';
  window.open(downloadUrl, '_blank');
};


const DownloadPage: React.FC = () => {
  return (
    <div className="pt-24 pb-20 text-white bg-gray-900">
      <div className="container px-4 mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mx-auto max-w-4xl"
        >
          <h1 className="mb-6 text-4xl font-bold text-center md:text-5xl">
            Download WinMax Optimizer
          </h1>

          <div className="p-8 mb-12 bg-gray-800 rounded-xl shadow-xl">
            <div className="flex justify-center items-center mb-8">
              <WindowsLogo className="mr-4 w-12 h-12 text-primary-400" />
              <div>
                <h2 className="text-2xl font-bold">Windows Version</h2>
                <p className="text-gray-400">v2.0.1 - Latest Release</p>
              </div>
            </div>

            <div className="space-y-6">
              <div className="flex items-center text-gray-300">
                <CheckCircle size={20} className="mr-2 text-primary-400" />
                <span>Windows 10 and 11 supported</span>
              </div>
              <div className="flex items-center text-gray-300">
                <CheckCircle size={20} className="mr-2 text-primary-400" />
                <span>Requires .NET 8 or higher</span>
              </div>
              <div className="flex items-center text-gray-300">
                <CheckCircle size={20} className="mr-2 text-primary-400" />
                <span>64-bit systems only</span>
              </div>
            </div>

            <button onClick={handleDownload} className="flex justify-center items-center px-6 py-4 mt-8 w-full font-bold text-white bg-primary-500 rounded-lg transition-colors hover:bg-primary-600">
              <Download size={20} className="mr-2" />
              Download Now (64-bit)
            </button>
          </div>

          <div className="grid gap-8 md:grid-cols-2">
            <div className="p-6 bg-gray-800 rounded-xl">
              <h3 className="mb-4 text-xl font-bold">System Requirements</h3>
              <ul className="space-y-3 text-gray-300">
                <li>• Windows 10 or Windows 11</li>
                <li>• .NET 8 Runtime</li>
                <li>• 4GB RAM minimum</li>
                <li>• 100MB free disk space</li>
                <li>• 64-bit processor</li>
              </ul>
            </div>

            <div className="p-6 bg-gray-800 rounded-xl">
              <h3 className="mb-4 text-xl font-bold">Key Features</h3>
              <ul className="space-y-3 text-gray-300">
                <li>• Advanced System Cleaner</li>
                <li>• Telemetry Control</li>
                <li>• Visual Effects Optimizer</li>
                <li>• Service Manager</li>
                <li>• Startup Optimizer</li>
              </ul>
            </div>
          </div>

          <div className="p-6 mt-12 rounded-lg border bg-yellow-900/30 border-yellow-700/50">
            <div className="flex items-start">
              <AlertTriangle size={24} className="flex-shrink-0 mt-1 mr-3 text-yellow-500" />
              <div>
                <h4 className="mb-2 text-lg font-semibold text-yellow-500">Important Note</h4>
                <p className="text-gray-300">
                  Make sure to download and install the .NET 8 Runtime before installing WinMax Optimizer.
                  You can download it from the official Microsoft website.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default DownloadPage;